import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/250610/velans-le_desertsand-{nnn}.png',
}

export default {
  supports360: false,
  layers: [body],
  resolveOptions: () => ({}),
}
